import React, { SVGProps } from 'react';
const download = (props: SVGProps<SVGSVGElement>): JSX.Element => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M6.667 26.667h18.667V24H6.667zM25.333 12H20V4h-8v8H6.667L16 21.333z" /></svg>;
export default download;